/**
 * Dependencies
 */
import { groupBy } from 'lodash'

/**
 * Output the OPEX data grouped by category
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Object}
 */
const groupedData = (state, getters) => {
    return groupBy(getters.filteredDataset.map(row => {
        return {
            id: row.id,
            name: row.name,
            category: row.category,
            data: row.data,
            url: row.url,
            showForm: false
        }
    }), 'category')
}

/**
 * Get the generated colors palette
 *
 * @return {Array}
 */
const chartColors = (state, getters) => {
    return ['#4572A7', '#AA4643', '#89A54E', '#80699B', '#3D96AE', '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92']
}

/**
 * Lower case search term
 *
 * @param  {Object} state
 * @return {String}
 */
const formattedSearchTerm = (state) => state.searchTerm.toLowerCase()

/**
 * Filtered dataset by user input string
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Array}
 */
const filteredDataset = (state, getters) =>
    state.data.filter(
        row => row.name
            .toLowerCase()
            .includes(getters.formattedSearchTerm)
    )

/**
 * Return the appropriate dataset
 *
 * @param  {Object} state
 * @param  {Object} getters
 * @return {Object}
 */
const paginatedDataset = (state, getters) => {
    let keys = Object.keys(getters.groupedData)
    return keys.reduce((result, item, idx, arr) => {
        result[item] = getters.groupedData[item]
            .map(row => row.data)
            .reduce((r, a) => {
                a.forEach((b, i) => {
                    let val = r[i] ? r[i].value : 0
                    if (r[i]) {
                        r[i].value = val + b.value
                    } else {
                        r.push({
                            value: b.value,
                            value_type: b.value_type
                        })
                    }
                })
                return r
            }, [])
        return result
    }, {})
}

/**
 * Calculate the total number of pages
 *
 * @param  {Object} state
 * @return {Number}
 */
const totalPages = (state) => {
    let max = (state.meta.index.length + 1) / (state.pageLimit || 1)

    return state.pageLimit ? Math.ceil(max) : null
}

/**
 * Calculate the data offset to use
 *
 * @param  {Object} state
 * @return {Number}
 */
const offset = (state) =>
    state.pageLimit ? (state.currentPage - 1) * state.pageLimit : null

/**
 * Determine whether the user can paginate the dataset
 *
 * @return {Boolean}
 */
const canPaginate = (state, getters) =>
    state.pageLimit !== null && getters.totalPages > 1

/**
 * Trasform the dataset into a chart-renederable object
 *
 * @return {Object}
 */
const chartData = (state, getters) => {
    let keys = Object.keys(getters.paginatedDataset)
    return {
        labels: keys,
        datasets: [{
            borderWidth: 1,
            borderColor: '#76acd4',
            backgroundColor: getters.chartColors,
            data: keys.map(key => getters.paginatedDataset[key][1].value)
        }]
    }
}

/**
 * Trasform the dataset into a chart-renederable object
 *
 * @param  {Object} state
 * @return {Array}
 */
const totals = state => {
    return state.data.reduce((result, item) => {
        item.data.forEach((i, idx) => {
            if (typeof result[idx] === 'undefined') {
                result[idx] = {
                    value: i.value,
                    value_type: i.value_type
                }
            } else {
                result[idx].value += i.value
            }
        })
        return result
    }, [])
}

export default {
    totals,
    offset,
    chartData,
    totalPages,
    canPaginate,
    groupedData,
    chartColors,
    filteredDataset,
    paginatedDataset,
    formattedSearchTerm
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/opex-pro-forma/getters.js